import { QUESTION_TYPE__FORMULA } from '../../../constants';
import Question from '../Question';
import {
  INSUFFICIENT_DATA_TEXT,
  isInsufficientDataError,
} from '../../../utils/insufficientData';

export default class QuestionFormula extends Question {
  constructor(doc) {
    super(doc);
    this.type = this.type || QUESTION_TYPE__FORMULA;
  }

  /**
   * @param {object} answer
   * @param {object} options
   * @returns {string | null}
   */
  formatAnswer(answer, options) {
    // TECH-3934 (D6): below the minimum answered there is no value, only this error.
    if (answer && isInsufficientDataError(answer.error)) {
      return INSUFFICIENT_DATA_TEXT;
    }
    if (answer && typeof answer.value === 'number') {
      const { value } = answer;
      if (Number.isFinite(value)) {
        const precission = this.getPrecision();
        if (typeof precission === 'number') {
          return value.toFixed(precission);
        }
        return value.toString();
      }
      return null;
    }
    return super.formatAnswer(answer, options);
  }
}

QuestionFormula.expectedRawKeys = ['value', 'error'];
QuestionFormula.expectedValueType = {};
QuestionFormula.editorSettings = {};

Question.types[QUESTION_TYPE__FORMULA] = QuestionFormula;
